import { loadIntercom } from 'next-intercom'
import { memo } from 'react'

interface IPropTypes {
  appId: string
}
function Intercom({ appId }: IPropTypes) {
  if (appId) {
    loadIntercom({
      appId: appId.toString(),
      ssr: false,
      initWindow: true,
      delay: 3000,
    })
  }

  return <></>
}

export default memo(Intercom)
